
export function buildTreeKeyToRootColumnMap(treeNodes) {
  const keyToRoot = new Map()
  const walk = (nodes, rootKey = undefined) => {
    for (const node of nodes || []) {
      if (node?.key == null) continue
      const columnRoot = rootKey ?? node.key
      keyToRoot.set(node.key, columnRoot)
      if (node.children?.length) {
        walk(node.children, columnRoot)
      }
    }
  }
  walk(treeNodes, undefined)
  return keyToRoot
}

export function normalizeTreeCheckedPayloadToLeafKeys(checkedPayload) {
  if (Array.isArray(checkedPayload)) return checkedPayload
  if (checkedPayload?.checked != null) return [...checkedPayload.checked]
  return []
}

export function countDistinctTreeParentRoots(leafKeys, treeData) {
  const map = buildTreeKeyToRootColumnMap(treeData)
  const roots = new Set()
  for (const key of leafKeys || []) {
    roots.add(map.get(key) ?? key)
  }
  return roots.size
}

export function exceedsTreeParentLimit(leafKeys, treeData, maxParents) {
  if (maxParents == null || maxParents <= 0) return false
  return countDistinctTreeParentRoots(leafKeys, treeData) > maxParents
}
